import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import UINavListItem from './UINavListItem';
export default class UISideNavItem extends Component {
  render() {
    const _this$props = this.props,
          {
      children
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return /*#__PURE__*/_jsx(UINavListItem, Object.assign({
      iconRight: children != null ? 'down' : null
    }, rest, {
      children: children
    }));
  }

}
UISideNavItem.displayName = 'UISideNavItem';
UISideNavItem.propTypes = Object.assign({}, UINavListItem.propTypes);
UISideNavItem.defaultProps = Object.assign({}, UINavListItem.defaultProps);